(function configureUnpoly(w, d) {
    // CSS selector that Unpoly should treat as a "hungry" element and refresh when needed.
    var HUNGRY_SELECTOR = 'style#block-styles';

    // Read the global Unpoly instance from window.
    var unpoly = w.up;
    if (!unpoly) {
        return false;
    }

    // Hide Unpoly's startup banner in the browser console.
    if (unpoly.log && unpoly.log.config) {
        unpoly.log.config.banner = false;
    }

    // Include stylesheet link tags that contain the word `stylesheet`
    // - fixes an issue with link tags with `rel="stylesheet preload"`
    unpoly.script.config.assetSelectors = [
        ...unpoly.script.config.assetSelectors,
        'link[rel~="stylesheet"]'
    ];

    // Safely get the list of selectors Unpoly watches for replacement.
    var hungrySelectors = unpoly.radio &&
        unpoly.radio.config &&
        unpoly.radio.config.hungrySelectors;

    // Add the selector once (idempotent) so repeated script runs do not create duplicates.
    if (Array.isArray(hungrySelectors) && hungrySelectors.indexOf(HUNGRY_SELECTOR) === -1) {
        hungrySelectors.push(HUNGRY_SELECTOR);
    }

    function isStylesheet(asset) {
        return asset.matches('link[rel~=stylesheet]');
    }

    // When the assets change, get rid of all old stylesheets and load the new ones
    unpoly.on('up:assets:changed', function({ oldAssets, newAssets }) {
        let oldStylesheets = unpoly.util.filter(oldAssets, isStylesheet);
        let newStylesheets = unpoly.util.filter(newAssets, isStylesheet);

        for (let oldStylesheet of oldStylesheets) {
            oldStylesheet.remove();
        }

        for (let newStylesheet of newStylesheets) {
            d.head.append(newStylesheet);
        }
    });
})(window, document);